import React from 'react';
import Grid from '@material-ui/core/Grid';
import { FPCard as Card, FPCardContent as CardContent } from 'UI/components/atoms/FPCard';
import { getId } from 'UI/utils';

import DailyStatsFooter from '../../home/DailyStats/DailyStatsFooter';
import { SummaryTotalsV2 } from '../SummaryTotals/SummaryTotalsV2';

import { useStyles } from './styles';

const getCardColumns = hasChild =>
  hasChild
    ? { xs: 12 }
    : {
        xs: 12,
        sm: 6,
        md: 4
      };

const StatsWrapper = ({ FooterProps, isLoading, scope, shouldSetMinHeight, stats }) => {
  const classes = useStyles({ isLoading, shouldSetMinHeight });

  return stats.map(stat => {
    const finalFooterProps = stat?.FooterProps || FooterProps;

    return (
      stat.shouldShow && (
        <Grid item key={getId()} {...getCardColumns(stat.child)}>
          <Card>
            <CardContent
              className={classes.cardContent}
              headerProps={{
                title: stat.title,
                subheader: stat?.subheader || scope.option1,
                className: classes.headerAction
              }}
              footerProps={{
                CustomFooter: stat.shouldShowFooter && (
                  <DailyStatsFooter type="dashboard" {...finalFooterProps} />
                )
              }}
              variant={stat.child ? 'tight' : 'regular'}
            >
              {stat.child || <SummaryTotalsV2 isLoading={isLoading} data={stat.data} />}
            </CardContent>
          </Card>
        </Grid>
      )
    );
  });
};

export default StatsWrapper;
